(function () {
  'use strict';

  var MODAL_ID   = 'kenele-zimg-modal';
  var ACTIVE_CLS = 'kenele-zimg-active';
  var LOCK_CLS   = 'kenele-zimg-lock';

  function buildModal() {
    if (document.getElementById(MODAL_ID)) return;

    var overlay = document.createElement('div');
    overlay.id        = MODAL_ID;
    overlay.className = 'kenele-zimg-overlay';
    overlay.setAttribute('role',       'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', '画像の拡大表示');

    var inner = document.createElement('div');
    inner.className = 'kenele-zimg-inner';

    var img = document.createElement('img');
    img.className = 'kenele-zimg-picture';
    img.alt = '';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'kenele-zimg-close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = '&#215;';

    inner.appendChild(img);
    overlay.appendChild(closeBtn);
    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeModal();
    });

    overlay.addEventListener('click', function (e) {
      if (!inner.contains(e.target)) closeModal();
    });
  }

  function openModal(src, alt) {
    var overlay = document.getElementById(MODAL_ID);
    if (!overlay) return;
    var img = overlay.querySelector('.kenele-zimg-picture');
    img.src = src;
    img.alt = alt || '';
    overlay.classList.add(ACTIVE_CLS);
    document.body.classList.add(LOCK_CLS);
    overlay.querySelector('.kenele-zimg-close').focus();
  }

  function closeModal() {
    var overlay = document.getElementById(MODAL_ID);
    if (!overlay) return;
    overlay.classList.remove(ACTIVE_CLS);
    document.body.classList.remove(LOCK_CLS);
    var img = overlay.querySelector('.kenele-zimg-picture');
    if (img) { img.src = ''; img.alt = ''; }
  }

  function init() {
    buildModal();

    document.querySelectorAll('img.js-zoom-image').forEach(function (el) {
      el.addEventListener('click', function () {
        openModal(
          el.getAttribute('data-zoom-src') || el.src,
          el.getAttribute('alt') || ''
        );
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var overlay = document.getElementById(MODAL_ID);
        if (overlay && overlay.classList.contains(ACTIVE_CLS)) closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
